var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0755B280-3C34-4F0C-A3CE-9515B8EF2EEC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selection-Menus",
    transform: "translate(-889.000000, -1574.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(117.000000, 1441.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-5",
    transform: "translate(107.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(642.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-light",
    transform: "translate(23.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5384615,1.53846154 C21.5384615,0.692307692 20.8461538,0 20,0 C19.1538462,0 18.4615385,0.692307692 18.4615385,1.53846154 L18.4615385,18.4615385 L1.53846154,18.4615385 C0.692307692,18.4615385 0,19.1538462 0,20 C0,20.8461538 0.692307692,21.5384615 1.53846154,21.5384615 L18.4615385,21.5384615 L18.4615385,38.4615385 C18.4615385,39.3076923 19.1538462,40 20,40 C20.8461538,40 21.5384615,39.3076923 21.5384615,38.4615385 L21.5384615,21.5384615 L38.4615385,21.5384615 C39.3076923,21.5384615 40,20.8461538 40,20 C40,19.1538462 39.3076923,18.4615385 38.4615385,18.4615385 L21.5384615,18.4615385 L21.5384615,1.53846154 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLight);
export default __webpack_public_path__ + "static/media/plus-light.be40405d2f5330437fcead496c282338.svg";
export { ForwardRef as ReactComponent };